import {
  V2ListAttachmentTypesForAccountApiArg,
  useV2ListAttachmentTypesForAccountQuery,
} from "@generated";
import type { AttachmentType } from "../types";

export interface UseAttachmentTypesListArgs {
  page?: V2ListAttachmentTypesForAccountApiArg["page"];
  filter?: V2ListAttachmentTypesForAccountApiArg["filter"];
}

export interface AttachmentTypesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useAttachmentTypesList = ({
  page,
  filter,
}: UseAttachmentTypesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListAttachmentTypesForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: AttachmentType[] = (data?.data ?? []).map((attachmentType) => ({
    id: String(attachmentType.id),
    name: attachmentType.attributes?.name ?? "",
    // The wire serializes the enum as kebab `document-type`, even though the
    // generated type names it `document_type` (see jsonapi attribute keys note).
    documentType:
      (attachmentType.attributes as Record<string, string> | undefined)?.[
        "document-type"
      ] ?? "",
  }));

  const pageMeta: AttachmentTypesListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useAttachmentTypesList;
